import paymentTransaction from '../../Actions/paymentTransaction';
const { types } = paymentTransaction;

const initialState = {
    config: null,
    showStampInvoiceModal: false
};

const paymentTransactionReducer = (state = initialState, action) => {

    switch (action.type) {	
        case types.SET_CONFIG_TRANSACTION:        
			return {
				...state,
				config: action.data
            }
        case types.SHOW_STAMP_INVOICE_MODAL: {
            return {
                ...state,
                showStampInvoiceModal: action.status
            }
        }      
        default:
            return state;
    }
}

export default paymentTransactionReducer;